var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"readText"},[_c('div',{staticClass:"readTextContainer"},[_c('textCover',{attrs:{"textObj":_vm.textObj}}),_c('textContainer',{attrs:{"textObj":_vm.textObj}})],1),_c('textNav',{on:{"changeView":_vm.changeView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }